
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import FiltersSmall from '@/components/common/filter/FiltersSmall.vue';
import FiltersBig from '@/components/common/filter/FiltersBig.vue';
import NButton from '@/uikit/buttons/NButton.vue';
import NButtonGroup from '@/uikit/buttons/NButtonGroup.vue';
import NBaseBar from '@/uikit/bars/NBaseBar.vue';
import { EditorMode, EditorModes, EditorSections } from '@/pages/webhooks/components/types';
import WebhooksFiltersEditorJson from '@/pages/webhooks/components/WebhooksFiltersEditorJson.vue';
import WebhooksFiltersEditorVisual from '@/pages/webhooks/components/WebhooksFiltersEditorVisual.vue';
import { Webhook } from '@/api';
import NModalWindow from '@/uikit/modal-window/NModalWindow.vue';
import { isSectionAvailable } from '@/pages/webhooks/components/utils';

@Options({
  name: 'WebhooksFiltersEditor',
  components: { NModalWindow, WebhooksFiltersEditorVisual, WebhooksFiltersEditorJson, NBaseBar, NButtonGroup, NButton, FiltersBig, FiltersSmall }
})
export default class WebhooksFiltersEditor extends Vue {
  @Prop({ type: Object, required: true })
  readonly item!: Webhook;

  private mode: EditorMode = EditorModes.Visual;
  private largeFiltersActive = false;
  private resetModalActive = false;

  get hasAvailableSections() {
    return !!Object.values(EditorSections).filter(isSectionAvailable).length;
  }

  get isVisualMode() {
    return this.mode === EditorModes.Visual;
  }

  get modeItems() {
    const visual = { value: EditorModes.Visual, label: this.$t('webhooks.edit_mode_visual', 'f') };
    const manual = { value: EditorModes.Json, label: this.$t('webhooks.edit_mode_json', 'f') };

    return this.hasAvailableSections ? [visual, manual] : [manual];
  }

  get hasChanges() {
    return this.item.filters && Object.keys(this.item.filters).length > 0;
  }

  showResetModal() {
    this.resetModalActive = true;
  }

  reset() {
    this.item.filters = {};
    this.largeFiltersActive = false;
    this.resetModalActive = false;
  }
}
